
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    getCalculationOperations,
    getPricelistData
} from '../../reducers/project';

import projectGetActions from '../../sagas/project';

import OperationView from './Operation.view';

const Operation = ({
    operation,
    quantity,
    usek,
    usekAttributes
}) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const calculationOperations = useSelector(state => getCalculationOperations(state.project));
    const pricelistData = useSelector(state => getPricelistData(state.project));

    const getOperationItems = () => {
        return pricelistData.items.filter(item => {
            return (item.opId === operation.id);
        });
    }

    const getCalculationOperation = () => {
        return calculationOperations[`${usek.properties.id_usek}_${operation.id}`];
    }

    const handleOperationItemChange = (operationItem) => {
        projectActions.setCalculationOperation(
            usek.properties.id_usek,
            operation.id, operationItem.id,
            operationItem.price
        );
    }

    return (
        <OperationView
            operation={operation}
            operationItems={getOperationItems()}
            onOperationItemChange={handleOperationItemChange}
            calculationOperation={getCalculationOperation()}
            quantity={quantity}
        />
    );
}

export default Operation;
